import React from 'react';
import { createRoot } from 'react-dom/client'; // Importa createRoot da react-dom invece di ReactDOM
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Usa createRoot invece di ReactDOM.render
const root = createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Se vuoi misurare le prestazioni della tua app, passa una funzione
// per registrare i risultati (ad esempio: reportWebVitals(console.log))
// o inviali a un endpoint di analisi. Ulteriori informazioni: https://bit.ly/CRA-vitals
reportWebVitals();
